import React, { useCallback, useState, useMemo } from "react";
import PropTypes from "prop-types";

import styles from "./TextInput.module.css";

const TextInput = ({
  label,
  value,
  setValue,
  placeholder,
  disabled,
  onKeyPressEnter,
  onBlur: onBlurProp,
  onFocus: onFocusProp,
  type,
  multiline,
  rows,
}) => {
  const [isActive, setIsActive] = useState(false);

  const wrapperClassName = useMemo(() => (
    [
      styles.textInput,
      isActive ? styles.active : null,
      !!value ? styles.filled : null,
      disabled ? styles.disabled : null,
    ].filter((x) => !!x).join(" ")
  ), [isActive, value, disabled]);

  const onChange = useCallback((e) => {
    setValue(e.target.value);
  }, [setValue]);

  const onFocus = useCallback((event) => {
    setIsActive(true);
    onFocusProp?.(event);
  }, [onFocusProp]);

  const onBlur = useCallback((event) => {
    setIsActive(false);
    onBlurProp?.(event);
  }, [onBlurProp]);

  const onKeyPress = useCallback((e) => {
    if (!e) e = window.event;
    var keyCode = e.code || e.key;
    if (keyCode === "Enter" && onKeyPressEnter) {
      onKeyPressEnter();
      return false;
    }
  }, [onKeyPressEnter]);

  const InputComponent = multiline ? "textarea" : "input";

  const inputProps = useMemo(() => {
    const commonProps = {
      value: value?.toString(),
      onChange,
      placeholder,
      onFocus,
      onBlur,
      required: "required",
      onKeyPress,
      disabled: disabled ? "disabled" : false,
    };

    if (multiline) {
      return {
        ...commonProps,
        rows,
      };
    }

    return {
      ...commonProps,
      type,
    };
  }, [disabled, multiline, onBlur, onChange, onFocus, onKeyPress, placeholder, rows, type, value]);

  return (
    <div className={wrapperClassName}>
      <label>{label}</label>
      <InputComponent {...inputProps} />
      {/* <p>// place for errors</p> */}
    </div>
  );
};

TextInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  setValue: PropTypes.func.isRequired,
  // validate: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onKeyPressEnter: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
};

TextInput.defaultProps = {
  label: null,
  value: "",
  // validate: () => {},
  placeholder: null,
  disabled: false,
  onKeyPressEnter: null,
  onBlur: null,
  onFocus: null,
  type: "text",
  multiline: false,
  rows: 3,
};

export default TextInput;
